import { combineEpics, Epic as _Epic } from 'redux-observable';

import { AppState } from './appState';
import { AppAction } from './rootAction';

import * as service from './rootService';

import { navigationRedirectEpicFactory } from 'src/modules/navigation/epics/redirectEpic';
import { cpProgramEpicFactory } from 'src/modules/programs/cpProgram/epics/cpProgramEpics';
import { programsEpicFactory } from 'src/modules/programs/epics/programsEpics';
import { feedbackEpicFactory } from 'src/modules/programs/feedback/epics/feedbackEpics';
import { surveysEpicFactory } from 'src/modules/programs/surveys/epics/surveysEpics';
import { videosEpicFactory } from 'src/modules/videos/epics/videosEpic';

// LEGACY: TO BE REMOVED WHEN MIGRATION FROM REDUX-OBSERVABLES TO REDUX-REMATCH FINISHED
export const rootEpic = combineEpics(
    cpProgramEpicFactory(service.cPProgramService),
    videosEpicFactory(service.contentful),
    surveysEpicFactory(service.surveysService),
    feedbackEpicFactory(service.feedbackService),
    programsEpicFactory(service.programsService),
    navigationRedirectEpicFactory(),
);

export type Epic = _Epic<AppAction, AppState>;
